import AwardWinnerResults from './AwardWinnerResults';

class AwardWinnerWithPointsResults extends AwardWinnerResults {
  AwardShow = '';

  Points = 0;

  CadrePoints = 0;

  Year = 0;

  Status = '';

  SubCategory = '';

  HoldingCompany = '';

  AgencyNetwork = '';

  AgencyName = '';

  Country = '';

  Advertiser = '';

  Region = '';

  Brand = '';

  AdvertiserCategory = '';

  UploadedBy = '';

  UploadedDate = '';

  NumberOfWorks = '';
  
  campaignTitle = '';

  campaignSfvId = 0;

  constructor(data) {
    super(data);
    
    this.AwardShow = data.awardShow;
    this.Points = data.points;
    this.CadrePoints = data.cadrePoints;
    this.Year = data.year;
    this.Status = data.status;
    this.SubCategory = data.subCategory;
    this.HoldingCompany = data.holdingCompany;
    this.AgencyNetwork = data.agencyNetwork;
    this.AgencyName = data.agencyName;
    this.Country = data.country;
    this.Advertiser = data.advertiser;
    this.Region = data.region;
    this.Brand = data.brand;
    this.AdvertiserCategory = data.advertiserCategory;
    this.UploadedBy = data.uploadedBy;
    this.UploadedDate = data.uploadedDate;
    this.NumberOfWorks = data.numberOfWorks;
    this.campaignSfvId = data.campaignSfvId;
    this.campaignTitle = data.campaign;
  }

  static fromObject(data) {
    return new AwardWinnerWithPointsResults(data);
  }

  static fromList(list) {
    return (list || []).map(AwardWinnerWithPointsResults.fromObject);
  }
}

export default AwardWinnerWithPointsResults;
